import { render, staticRenderFns } from "./BasicInfoView.vue?vue&type=template&id=d34b9d32"
import script from "./BasicInfoView.vue?vue&type=script&lang=js"
export * from "./BasicInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports